import { createSelector } from '@reduxjs/toolkit';
import { selectPriceLabel } from './selectPriceLabel';
import { selectPrice } from 'shared/selectors/jsonQuery';

export const selectPriceFilter = createSelector(
  [selectPrice, selectPriceLabel],
  ({ gte: min = null, lte: max = null }, label) => ({
    value: { min, max },
    label,
  }),
);
